module.exports = __webpack_public_path__ + "img/hainanshenmiao.aa7609cf.png";